import React from "react";
import { Form, Image } from "react-bootstrap";
import { Controller, useFormContext } from "react-hook-form";
import { BidFormInput, Facility } from "../types/type";

export const initialData_plan3 = [
    {
        usage_1: 0,
        usage_2: 0,
        usage_3: 0,
        usage_4: 0,
    }
];

const Plan3: React.FC<{ facility: Facility, confirm: boolean }> = ({ facility, confirm }) => {
    const { control, watch, setValue } = useFormContext<BidFormInput>();
    const is_custom = watch(`conditions.${facility.id}.is_custom`);
    const custom_check_1 = watch(`conditions.${facility.id}.custom_check_1`);
    const custom_check_2 = watch(`conditions.${facility.id}.custom_check_2`);
    const custom_check_3 = watch(`conditions.${facility.id}.custom_check_3`);

    let visible = false;
    if (is_custom) {
        visible = (!custom_check_1 && custom_check_2 && !custom_check_3);
    } else {
        visible = (facility.contract_type == "SEASONAL_HOLIDAYS");
    }
    const record = 1;

    const usages = Array.from({ length: record }, (_, i) => (
        <tr key={i}>
            {
                <>
                    <td className="w-m-140 py-2">
                        <div className="input-group">
                            <Controller
                                name={`conditions.${facility.id}.usage.${i}.usage_1`}
                                control={control}
                                rules={{
                                    required: { value: true, message: "必須入力" },
                                    validate: (value) => {
                                        if (value !== null || "") {
                                            return true;
                                        }
                                        return "数値を入力してください";
                                    },
                                }}
                                render={({ field }) => (
                                    <input className="form-control mb-3 rounded-0 name-required  text-right"
                                        {...field}
                                        placeholder=""
                                        disabled={confirm}
                                        type="number"

                                    />
                                )}
                            />
                            <div className="input-group-append">
                                <Image className="ml-3" width="15" src="assets/images/bidding-condition/kwh.svg" />
                            </div>
                        </div>
                    </td>
                    <td className="w-m-140 py-2">
                        <div className="input-group">
                            <Controller
                                name={`conditions.${facility.id}.usage.${i}.usage_2`}
                                control={control}
                                rules={{
                                    required: { value: true, message: "必須入力" },
                                    validate: (value) => {
                                        if (value !== null || "") {
                                            return true;
                                        }
                                        return "数値を入力してください";
                                    },
                                }}
                                render={({ field }) => (
                                    <input className="form-control mb-3 rounded-0 name-required  text-right"
                                        {...field}
                                        placeholder=""
                                        disabled={confirm}
                                        type="number"

                                    />
                                )}
                            />
                            <div className="input-group-append">
                                <Image className="ml-3" width="15" src="assets/images/bidding-condition/kwh.svg" />
                            </div>
                        </div>
                    </td>
                    <td className="w-m-140 py-2">
                        <div className="input-group">
                            <Controller
                                name={`conditions.${facility.id}.usage.${i}.usage_3`}
                                control={control}
                                rules={{
                                    required: { value: true, message: "必須入力" },
                                    validate: (value) => {
                                        if (value !== null || "") {
                                            return true;
                                        }
                                        return "数値を入力してください";
                                    },
                                }}
                                render={({ field }) => (
                                    <input className="form-control mb-3 rounded-0 name-required  text-right"
                                        {...field}
                                        placeholder=""
                                        disabled={confirm}
                                        type="number"
                                    />
                                )}
                            />
                            <div className="input-group-append">
                                <Image className="ml-3" width="15" src="assets/images/bidding-condition/kwh.svg" />
                            </div>
                        </div>
                    </td>
                    <td className="w-m-140 py-2">
                        <div className="input-group">
                            <Controller
                                name={`conditions.${facility.id}.usage.${i}.usage_4`}
                                control={control}
                                rules={{
                                    required: { value: true, message: "必須入力" },
                                    validate: (value) => {
                                        if (value !== null || "") {
                                            return true;
                                        }
                                        return "数値を入力してください";
                                    },
                                }}
                                render={({ field }) => (
                                    <input className="form-control mb-3 rounded-0 name-required text-right"
                                        {...field}
                                        placeholder=""
                                        disabled={confirm}
                                        type="number"

                                    />
                                )}
                            />
                            <div className="input-group-append">
                                <Image className="ml-3" width="15" src="assets/images/bidding-condition/kwh.svg" />
                            </div>
                        </div>
                    </td>
                </>
            }
        </tr >
    ));



    return (
        <table className={`table table-bordered table-vertical-align-middle text-center plan ${visible ? '' : 'd-none'}`} >
            <thead>
                <tr>
                    <td scope="col" colSpan={2} className="bg-ass-table fw-400 py-1">夏季</td>
                    <td scope="col" colSpan={2} className="bg-ass-table fw-400 py-1">その他季</td>
                </tr>
                <tr>
                    <td className="bg-ass-table fw-400 py-1">平日</td>
                    <td className="bg-ass-table fw-400 py-1">土日祝</td>
                    <td className="bg-ass-table fw-400 py-1">平日</td>
                    <td className="bg-ass-table fw-400 py-1">土日祝</td>
                </tr>
            </thead>
            <tbody className="bg-white">
                {usages}
            </tbody>
        </table>
    )
}

export default Plan3;